import request from '@/utils/request'

// ==================== 会员管理 ====================

/**
 * 查询会员分页列表
 */
export function listMember(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query
  })
}

/**
 * 获取会员详情
 */
export function getMemberDetail(id) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 新增会员
 */
export function addMember(data) {
  return request({
    url: '/biz/user/add',
    method: 'post',
    data
  })
}

/**
 * 购买会员
 */
export function buyMember(data) {
  return request({
    url: '/biz/user/buyMember',
    method: 'post',
    data
  })
}

/**
 * 充值余额
 */
export function rechargeBalance(data) {
  return request({
    url: '/biz/user/rechargeBalance',
    method: 'post',
    data
  })
}


